import React from "react";
import InventorySlot from "./InventorySlot";
import { ARMOR_LAYOUT, getArmorSlotAriaLabel } from "@/data/vipSimulatorCatalog";
import { useI18n } from "@/i18n/I18nProvider";

export default function ArmorSlots({ armor, renderSlotContent, quickEquipBar = null }) {
    const { t, lang } = useI18n();
    return (
        <div className="vip-sim-armor-wrap">
            {quickEquipBar}
            <div className="vip-sim-armor-grid" aria-label={t("simulator.armor.gridAria")}>
            {ARMOR_LAYOUT.map((row) => {
                const id = `slot-armor-${row.accept}`;
                const placement = armor[row.accept];
                return (
                    <div key={row.accept} className="vip-sim-armor-cell">
                        <InventorySlot
                            zone="armor"
                            accept={row.accept}
                            className="vip-sim-slot--armor"
                            aria-label={getArmorSlotAriaLabel(row.accept, lang)}
                        >
                            {placement ? (
                                renderSlotContent(placement, row.accept)
                            ) : (
                                <div
                                    className={`vip-sim-armor-ghost${row.ghostClass ? ` ${row.ghostClass}` : ""}`}
                                    aria-hidden
                                >
                                    {row.ghost ? (
                                        <img src={row.ghost} alt="" draggable={false} />
                                    ) : null}
                                </div>
                            )}
                        </InventorySlot>
                    </div>
                );
            })}
            </div>
        </div>
    );
}
